<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Experiências</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <quicksearch v-model="quicksearch"></quicksearch>
        </div>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        :no-data-text="noResultText"
        :no-results-text="noResultText"
        loading-text="Carregando..."
        :loading="loading"
        :server-items-length="totalItems"
        :options.sync="options"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 30, 50],
          itemsPerPageText: 'Registros por página:'
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn @click="detailsModal = item.gateway_id" color="primary" fab text small dark>
            <v-icon>mdi-piggy-bank-outline</v-icon>
          </v-btn>
          <v-btn @click="transactionsModal = item.gateway_id" color="primary" fab text small dark>
            <v-icon>mdi-transfer</v-icon>
          </v-btn>
          <v-btn :href="'https://experiencia.heppi.io/organizacao/experiencia/' + item.id" target="_blank" color="primary" fab text small dark>
            <v-icon>mdi-open-in-new</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.publicado="{ item }">
          <v-chip :color="item.publicado === 'Sim' ? 'success' : 'grey'" small dark>
            {{ item.publicado }}
          </v-chip>
        </template>
        <template v-slot:item.valorTotal="{ item }">
          {{ formatCurrency(item.valorTotal) }}
        </template>
      </v-data-table>
    </v-container>
    <account-modal :accountId="detailsModal" @close="detailsModal = null"></account-modal>
    <v-dialog :value="!!transactionsModal" @click:outside="transactionsModal = null" max-width="90%">
      <v-card>
        <v-card-title>
          <div class="row align-center pa-0">
            <div class="col headline">Movimentações</div>
            <div class="col-auto pa-sm">
              <v-btn fab text color="default" @click="transactionsModal = null">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card-text class="pt-3 pb-6">
          <v-tabs
            center-active
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab key="tab-withdraws" href="#tab-withdraws">Saques</v-tab>
            <v-tab key="tab-transfers" href="#tab-transfers">Pagto Fornecedor</v-tab>
            <v-tab-item key="tab-item-withdraws" value="tab-withdraws">
              <account-withdraws :accountId="transactionsModal"></account-withdraws>
            </v-tab-item>
            <v-tab-item key="tab-item-transfers" value="tab-transfers">
              <account-transfers :accountId="transactionsModal"></account-transfers>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import Quicksearch from '@/components/Quicksearch'
import AccountModal from '@/components/AccountModal'
import AccountTransfers from '@/components/AccountTransfers'
import AccountWithdraws from '@/components/AccountWithdraws.vue'

export default {
  name: 'experiences',
  components: {
    Quicksearch,
    AccountModal,
    AccountTransfers,
    AccountWithdraws
  },
  data: () => ({
    loading: false,
    quicksearch: '',
    detailsModal: null,
    transactionsModal: null,
    items: [],
    totalItems: 0,
    options: {},
    searchTimeout: null,
    headers: [
      {
        text: '',
        sortable: false,
        value: 'actions'
      },
      {
        text: 'Nome',
        value: 'nome'
      },
      {
        text: 'Local',
        value: 'local'
      },
      {
        text: 'Data Início',
        value: 'dataInicio'
      },
      {
        text: 'Data Fim',
        value: 'dataFim'
      },
      {
        text: 'Publicado',
        value: 'publicado'
      },
      {
        text: 'Valor Total',
        value: 'valorTotal',
        align: 'end'
      }
    ]
  }),
  computed: {
    noResultText () {
      return 'Nenhuma experiência encontrada'
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true
    },
    quicksearch () {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.options.page = 1
        this.getData()
      }, 500)
    }
  },
  methods: {
    formatCurrency (value) {
      if (!value) return 'R$ 0,00'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value)
    },
    async getData () {
      this.loading = true
      try {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options
        const params = {
          page: page || 1,
          limit: itemsPerPage || 30,
          search: this.quicksearch || '',
          sortBy: sortBy && sortBy.length > 0 ? sortBy[0] : '',
          sortDesc: sortBy && sortBy.length > 0 ? (sortDesc[0] ? 'DESC' : 'ASC') : ''
        }

        const response = await this.$http.get('https://n8n.heppi.io/webhook/9bdae94f-b88e-42a3-b1e2-adf35ba8878a', { params })

        if (response.data.success) {
          this.items = response.data.data
          this.totalItems = response.data.total
        }
      } catch (error) {
        console.error('Erro ao buscar dados:', error)
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          message: 'Erro ao carregar experiências',
          color: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    // getData será chamado automaticamente pelo watcher de options
  }
}
</script>
